// extracted by mini-css-extract-plugin
module.exports = {"policies":"policies___2kKnM","policy":"policy___1kEDf","title":"title___3Vamv","pre":"pre___2pxOA","empty":"empty___3-oHw","block":"block___1hGH6"};